import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CatButton } from '@blocks-react/components/Button';
import 'blocks-web-components/dist/bedrock/bedrock.css';
import styles from './SavedListTableEmptyState.module.scss';
import { BUTTON_VARIANTS } from '@app/constants/commonConstants';

const SavedListTableEmptyState = ({ openCreateListModal }) => {
  const [t] = useTranslation();
  const searchOptions = useSelector(s => s.account.searchOptions) || {};
  const { showMyLists, ...options } = searchOptions;
  const isSearchResultsEmpty = Object.values(options).filter(
    item => !!item
  ).length;

  return (
    <div className="d-flex justify-content-md-start justify-content-center p-3">
      {isSearchResultsEmpty ? (
        <div className={`${styles['empty-state--container']} u-fs--14`}>
          {t('SEARCH_FILTERS_NO_RESULTS')}
        </div>
      ) : (
        <div className="d-flex align-items-baseline">
          <div className={`${styles['empty-state--container']} u-fs--14`}>
            {t('NO_SAVED_LIST_AVAILABLE')}
          </div>
          <CatButton
            styleModifier={`${styles['create-list-button']}`}
            variant={BUTTON_VARIANTS.GHOST}
            onClick={() => openCreateListModal()}
          >
            {t('SL_CREATE_LIST')}
          </CatButton>
        </div>
      )}
    </div>
  );
};

SavedListTableEmptyState.propTypes = {
  openCreateListModal: PropTypes.func
};

export default SavedListTableEmptyState;
